export enum EightDirectionType {
    /**
     * 向左（自右侧）
     */
    LEFT = 'l',
    /**
     * 向上（自下部）
     */
    UP = 'u',
    /**
     * 向右（自左侧）
     */
    RIGHT = 'r',
    /**
     * 向下（自上部）
     */
    DOWN = 'd',
    /**
     * 向左上（自右下）
     */
    LEFT_UP = 'lu',
    /**
     * 向右上（自左下）
     */
    RIGHT_UP = 'ru',
    /**
     * 向左下（自右上）
     */
    LEFT_DOWN = 'ld',
    /**
     * 向右下（自左上）
     */
    RIGHT_DOWN = 'rd',
    DEFAULT = 'l',
}


export enum SideDirectionType {
    LEFT = 'l',
    UP = 'u',
    RIGHT = 'r',
    DOWN = 'd',
    DEFAULT = 'l',
}

export enum SwitchDirectionType {
    LEFT = 'l',
    RIGHT = 'r',
    DEFAULT = 'l',
}

export enum InOutDirectionType {
    OUT = 'out',
    IN = 'in',
    DEFAULT = 'out',
}
